import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../../modules/shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaNumeroCadastrosDoDia = () => {

    const [totalUsuariosDoDia, setTotalUsuariosDoDia] = useState('')

    const buscaNumeroCadastrosDoDia = useCallback(() => {
        http.get('/cadastros-hoje', )
        .then(res => {
            const nrCadastrosHoje = res.data
            setTotalUsuariosDoDia(nrCadastrosHoje)
        })
        .catch(() => setTotalUsuariosDoDia(''))
    }, [])

    useEffect(() => {
        buscaNumeroCadastrosDoDia()
    }, [buscaNumeroCadastrosDoDia])

    useRecarregaAoRenovarToken(buscaNumeroCadastrosDoDia)
  
    return {
        totalUsuariosDoDia
    };
  };
